function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - Date component
 * 
 */
import * as React from 'react';
import ErrorMessage from '../error-message/ErrorMessage';
import Info from '../info/Info';
import { MAX_FUTURE, MIN_FUTURE } from '../../data/Data';
import './DateInput.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class DateInput extends React.Component {
  constructor(props) {
    super(props);
    /**
     * Handle date change
     * @param {string} value
     */
    _defineProperty(this, "dateChange", (date = '') => {
      const {
        handleChange
      } = this.props;
      const newDate = date;
      handleChange(newDate);
      return newDate;
    });
    const maxFuture = props.maxFuture ? props.maxFuture : MAX_FUTURE;
    this.state = {
      maxFuture,
      minFuture: MIN_FUTURE
    };
  }
  render() {
    const {
      label,
      name,
      section,
      values
    } = this.props;
    let {
      error,
      errorMessage,
      required,
      valid
    } = values[name];
    const date = values[name].value;
    const classes = `form-element-container date ${name}${error ? ' error' : ''}${valid ? ' valid' : ''}`;
    errorMessage = !errorMessage ? `${label} is required` : errorMessage;
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      children: [/*#__PURE__*/_jsxs("label", {
        htmlFor: `${section}`,
        children: [label, required ? /*#__PURE__*/_jsx("span", {
          className: "required",
          children: "*"
        }) : '']
      }), /*#__PURE__*/_jsx("input", {
        type: "date",
        id: name,
        onChange: e => this.dateChange(e.target.value),
        value: date
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        message: errorMessage,
        error: error
      }), /*#__PURE__*/_jsx(Info, {
        info: "DD/MM/YYYY eg. 15/08/1980"
      })]
    });
  }
}
_defineProperty(DateInput, "defaultProps", {
  label: 'select',
  name: 'dateOfBirth',
  maxFuture: MAX_FUTURE,
  range: 'past',
  required: false,
  section: 'personal-details',
  values: {
    dateOfBirth: {
      error: false,
      required: true,
      valid: null,
      value: ''
    }
  }
});
export default DateInput;